import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import {
  OPEN_PANEL_MAIN_CONTENT_FULL_WIDTH_CONVERTER_TOKEN, OpenPanelMainContentFullWidthConverter
} from './open-panel-main-content-full-width.component.converter'
import {
  OPEN_PANEL_MAIN_CONTENT_FULL_WIDTH_ROW_CONVERTER_TOKEN, OpenPanelMainContentFullWidthRowConverter
} from './open-panel-main-content-full-width-row/open-panel-main-content-full-width-row.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        openPanelMainContentFullWidthFeature: {
          module: () => import('./open-panel-main-content-full-width.module').then((m) => m.OpenPanelMainContentFullWidthModule),
          cmsComponents: ['openpanelmaincontentfullwidth'],
          dependencies: [
            () => import('../open-panel-subcomponent-wrapper/open-panel-subcomponent-wrapper-feature.module').then(m => m.OpenPanelSubcomponentWrapperFeatureModule)
          ]
        },
      }
    }),
    {
      provide: OPEN_PANEL_MAIN_CONTENT_FULL_WIDTH_CONVERTER_TOKEN,
      useExisting: OpenPanelMainContentFullWidthConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        openpanelmaincontentfullwidth: OPEN_PANEL_MAIN_CONTENT_FULL_WIDTH_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: OPEN_PANEL_MAIN_CONTENT_FULL_WIDTH_ROW_CONVERTER_TOKEN,
      useClass: OpenPanelMainContentFullWidthRowConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        openpanelmaincontentfullwidthrow: OPEN_PANEL_MAIN_CONTENT_FULL_WIDTH_ROW_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class OpenPanelMainContentFullWidthFeatureModule {}

